function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.39 5.02L13.7 3.71L12.29 2.3L8.57999 6.01L12.29 9.72L13.7 8.31L12.45 7.06C14.99 7.3 16.99 9.41 16.99 12.01C16.99 14.77 14.75 17.01 11.99 17.01C9.22999 17.01 6.98999 14.77 6.98999 12.01H4.98999C4.98999 15.87 8.12999 19.01 11.99 19.01C15.85 19.01 18.99 15.87 18.99 12.01C18.99 8.15 16.06 5.24 12.38 5.03L12.39 5.02Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=Replay.js.map